import { render, staticRenderFns } from "./phase-header-component.vue?vue&type=template&id=71d46fb9"
import script from "./phase-header-component.vue?vue&type=script&lang=ts"
export * from "./phase-header-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d46fb9')) {
      api.createRecord('71d46fb9', component.options)
    } else {
      api.reload('71d46fb9', component.options)
    }
    module.hot.accept("./phase-header-component.vue?vue&type=template&id=71d46fb9", function () {
      api.rerender('71d46fb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/outage-clock/scorecard/phase-header-component.vue"
export default component.exports